import { render, staticRenderFns } from "./Ambassadors.vue?vue&type=template&id=05acd4da&scoped=true&"
import script from "./Ambassadors.vue?vue&type=script&lang=js&"
export * from "./Ambassadors.vue?vue&type=script&lang=js&"
import style0 from "./Ambassadors.vue?vue&type=style&index=0&id=05acd4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05acd4da",
  null
  
)

export default component.exports